export const ENERSI_ENV = process.env.REACT_APP_ENERSI_ENV?.trim().toUpperCase() || 'LOCAL'
export const ENERSI_SERVER = process.env.REACT_APP_ENERSI_SERVER || 'LOCAL'
export const ENERSI_CONF = process.env.REACT_APP_ENERSI_CONF || 'local'
export const ENERSI_VERSION = process.env.REACT_APP_ENERSI_VERSION || 'LOCAL.0.0.0'
